webpackJsonp([86],{

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)
__webpack_require__(583)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(654),
  /* scopeId */
  "data-v-46afb50e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  // When the bound element is inserted into the DOM...
  inserted: function inserted(el, binding, vnode) {
    if (!vnode.context.$store || ['color', 'shadow'].indexOf(binding.value) == -1) {
      return;
    }
    Handler.common(el);
    return binding.value == 'shadow' ? Handler.castShadow(el, vnode) : Handler.castColor(el, vnode);
  }
});
var Handler = {
  //shadow to brand color on focus
  //2 shadows - inner shadow - app color, outer shadow - brand color
  castShadow: function castShadow(el, vnode) {
    var shadow = vnode.context.$store.getters.shadow_color ? vnode.context.$store.getters.shadow_color["color"] : "#00ABC9";
    el.addEventListener('focus', function (event) {
      el.$prevShadow = Handler.getComputedStyle(el, "box-shadow");
      var shadow_primary = Handler.getComputedStyle(el, "background-color");
      shadow_primary = shadow_primary == "rgba(0, 0, 0, 0)" ? "#f4f5f9" : shadow_primary; //#f4f5f9 - app modal color
      el.style['box-shadow'] = "0 0 0 2px " + shadow_primary + ", 0 0 6px 3px " + shadow;
    });
    el.addEventListener('focusout', function (event) {
      el.style['box-shadow'] = el.$prevShadow;
    });
  },
  //highlight color to brand color on focus
  castColor: function castColor(el, vnode) {
    var color = vnode.context.$store.getters.color ? vnode.context.$store.getters.color["color"] : "#00ABC9";
    el.addEventListener('focus', function (event) {
      el.$color = Handler.getComputedStyle(el, "color");
      el.style['color'] = color;
      el.style['transform'] = "translateX(3px)";
      el.style['transition'] = "all 0.2s ease";
    });
    el.addEventListener('focusout', function (event) {
      el.style['color'] = el.$color;
      el.style['transform'] = "none";
    });
  },
  //common actions for both cast shadow and cast color
  common: function common(el) {
    el.addEventListener('keydown', function (event) {
      var keyCode = event.which || event.keyCode;
      if (keyCode == 13) {
        el.click();
      }
    });
    el.tabIndex = '0';
    el.style.outline = 'none';
  },
  getComputedStyle: function getComputedStyle(element, prop) {
    if (element.currentStyle) {
      return element.currentStyle[prop];
    } else if (window.getComputedStyle && window.getComputedStyle(element, null)) {
      return window.getComputedStyle(element, null).getPropertyValue(prop);
    } else {
      return element.style[prop];
    }
  }
};

/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);







/* harmony default export */ __webpack_exports__["a"] = ({
  // When the bound element is inserted into the DOM...
  inserted: function inserted(el, binding, vnode) {
    if (!binding.value && !window.app) {
      return;
    }
    AnimationFactory.call(el, vnode).start();
  }
});

var Helpers = {
  isAndroid: function isAndroid() {
    return !!navigator.userAgent.match(/Android/);
  },
  isInstagram: function isInstagram() {
    return navigator.userAgent.match(/FB/) || navigator.userAgent.match(/Instagram/i);
  }
};

var durations = {
  'headerTransitionDuration': 400,
  'appHeightTransitionDuration': 400,
  'appHeightTransitionTimeOut': 100
};

var AnimationFactory = function () {
  function AnimationFactory() {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, AnimationFactory);
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(AnimationFactory, null, [{
    key: 'call',
    value: function call(el, vnode) {
      return window.isMobile ? new MobileAnimation(el, vnode) : window.app.$inited ? new TranslateAnimation(el, vnode) : new AppearAnimation(el, vnode);
    }
  }]);

  return AnimationFactory;
}();

var Animation = function () {
  function Animation(el, vnode) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Animation);

    this.h = 'string';
    this.headerHeight = 0;
    this.appHeight = 0;
    this.minheight = 0;

    this.el = el;
    this.vnode = vnode;
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this, {
      app: document.getElementById("app"),
      header: document.getElementById("cb-header"),
      header_title: document.getElementById("cb-header-title"),
      body_wrap: document.getElementsByClassName("cb-body__wrap")[0],
      header_wizard: document.getElementById("cb-header-wizard")
    });
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Animation, [{
    key: 'focusOnFirstChild',
    value: function focusOnFirstChild() {
      var firstChild = this.app.querySelector("input:not([readonly=true])");
      window.setTimeout(function () {
        firstChild && firstChild.focus();
      }, 1000);
    }
  }]);

  return Animation;
}();

var MobileAnimation = function (_Animation) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MobileAnimation, _Animation);

  function MobileAnimation(el, vnode) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, MobileAnimation);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MobileAnimation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MobileAnimation)).call(this, el, vnode));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(MobileAnimation, [{
    key: 'start',
    value: function start() {
      var _this2 = this;

      this.beforeStart();
      window.cbTimeout(function () {
        _this2._start();
        _this2.afterStart();
      }, durations.headerTransitionDuration);
    }

    //------------------------------------------------------------------------------
    //  Fade the body content and start the animation
    //------------------------------------------------------------------------------

  }, {
    key: 'beforeStart',
    value: function beforeStart() {
      if (!(Helpers.isAndroid() && Helpers.isInstagram())) {
        window.addClass(this.el, "cb-body__animate");
      }
    }

    //------------------------------------------------------------------------------
    // Calculate body min height - flex property used in css
    //------------------------------------------------------------------------------

  }, {
    key: '_start',
    value: function _start() {
      this.headerHeight = this.header ? this.header.clientHeight : 0;
      this.body_wrap && (this.body_wrap.style.minHeight = window.innerHeight - this.headerHeight + "px");
    }
  }, {
    key: 'afterStart',
    value: function afterStart() {
      window.removeClass(this.app, "cb-hp--hidden");
      window.removeClass(this.el, "cb-body__animate");
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(MobileAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MobileAnimation.prototype), 'focusOnFirstChild', this).call(this);
    }
  }]);

  return MobileAnimation;
}(Animation);

var WebAnimation = function (_Animation2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(WebAnimation, _Animation2);

  function WebAnimation(el, vnode) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, WebAnimation);

    var _this3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WebAnimation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WebAnimation)).call(this, el, vnode));

    _this3.app.$animation = "start";
    return _this3;
  }

  //------------------------------------------------------------------------------
  //  Calculate app height - header height + body content height
  //  Fade the body content and start the animation
  //------------------------------------------------------------------------------

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(WebAnimation, [{
    key: 'beforeStart',
    value: function beforeStart() {
      this.h = this.el.clientHeight;
      this.headerHeight = this.header ? this.header.clientHeight : 0;
      //Final review hide full summary details
      var instance = this.vnode.componentInstance;
      if (this.h + this.headerHeight > window.innerHeight && instance && instance.$data.heightCheck != undefined) {
        instance.$data.heightCheck = true;
      }
      this.appHeight = this.h + this.headerHeight;
      window.addClass(this.el, "cb-body__animate");
      this.app.focus(); //donot remove - for accessibility
    }

    //------------------------------------------------------------------------------
    // set app height - min app height value : 480px
    // Calculate app margin => window height - app height
    // Min top margin - 20px
    //------------------------------------------------------------------------------

  }, {
    key: '_start',
    value: function _start() {
      //reconfirm header height
      this.headerHeight = this.header ? this.header.clientHeight : 0;
      this.appHeight = this.h + this.headerHeight;
      this.minHeight = this.appHeight > 480 ? this.appHeight : 480;
      this.app.style['height'] = this.minHeight + "px";
      var diff = window.innerHeight - this.minHeight;
      this.app.style.marginTop = (diff > 20 ? diff / 2.0 : 20) + "px";
      this.body_wrap && (this.body_wrap.style.minHeight = 480 - this.headerHeight + "px");
    }

    //------------------------------------------------------------------------------
    // reset app height to auto
    // fade in body content
    // update prevHeight variable to current app height
    //------------------------------------------------------------------------------


  }, {
    key: 'afterStart',
    value: function afterStart() {
      this.app.$prevHeight = this.app.clientHeight + "px";
      this.app.style.height = 'auto';
      this.app.$animation = "end";
      window.removeClass(this.app, "cb-hp--hidden");
      window.removeClass(this.el, "cb-body__animate");
    }
  }]);

  return WebAnimation;
}(Animation);

var AppearAnimation = function (_WebAnimation) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AppearAnimation, _WebAnimation);

  function AppearAnimation(el, vnode) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, AppearAnimation);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AppearAnimation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppearAnimation)).call(this, el, vnode));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(AppearAnimation, [{
    key: 'start',
    value: function start() {
      var _this5 = this;

      this.beforeStart();
      window.cbTimeout(function () {
        _this5._start();
        _this5.afterStart();
      }, durations.headerTransitionDuration);
    }
  }, {
    key: 'beforeStart',
    value: function beforeStart() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(AppearAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppearAnimation.prototype), 'beforeStart', this).call(this);
      if (this.header) {
        this.header.style['height'] = '64px'; //set max height to animate header title on page load
        this.header.style['overflow'] = 'hidden'; //set max height to animate header title on page load
      }
      this.header_title && (this.header_title.style['opacity'] = "0"); //hide title to equate the min height and then start animate the title
    }
  }, {
    key: '_start',
    value: function _start() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(AppearAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppearAnimation.prototype), '_start', this).call(this);
    }
  }, {
    key: 'afterStart',
    value: function afterStart() {
      window.removeClass(this.app, "cb-hp--hidden"); //remove fade in effect and add slide effect
      this.header && this.header_title && this.animateHeaderTitle();
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(AppearAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppearAnimation.prototype), 'afterStart', this).call(this);
      this.app.$inited = true;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(AppearAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppearAnimation.prototype), 'focusOnFirstChild', this).call(this);
    }
  }, {
    key: 'animateHeaderTitle',
    value: function animateHeaderTitle() {
      var _this6 = this;

      window.cbTimeout(function () {
        _this6.header_wizard && (_this6.header_wizard.style.opacity = "0"); //hide title to equate the min height and then start animate the title
        _this6.header.style.height = document.getElementById("cb-header-wrap").clientHeight + "px"; //remove max height and show title
        window.cbTimeout(function () {
          _this6.header.style.height = "auto";
          _this6.header.style.overflow = "initial";
          _this6.header.$prevHeight = _this6.header.clientHeight + "px"; //set prev header height
          _this6.app.$prevHeight = _this6.app.clientHeight + "px"; //set prev app height
          _this6.header_title && (_this6.header_title.style.opacity = "1"); //show header title
          _this6.header_wizard && (_this6.header_wizard.style.opacity = "1"); //show header title
        }, 400); //reset header behaviour
      }, 400); //show header title after 400ms - app fade in duration
    }
  }]);

  return AppearAnimation;
}(WebAnimation);

var TranslateAnimation = function (_WebAnimation2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TranslateAnimation, _WebAnimation2);

  function TranslateAnimation(el, vnode) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, TranslateAnimation);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TranslateAnimation.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TranslateAnimation)).call(this, el, vnode));
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(TranslateAnimation, [{
    key: 'start',
    value: function start() {
      var _this8 = this;

      this.beforeStart();
      window.cbTimeout(function () {
        _this8._start();
        window.cbTimeout(function () {
          return _this8.afterStart();
        }, _this8.afterStartWindowTimeout);
      }, durations.headerTransitionDuration);
    }
  }, {
    key: 'beforeStart',
    value: function beforeStart() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(TranslateAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TranslateAnimation.prototype), 'beforeStart', this).call(this);
      window.addClass(this.app, "cb-hp--transition");
      this.app.style.height = this.app.$prevHeight;
      document.documentElement.scrollTop = document.body.$scrollTop ? document.body.$scrollTop : 0;
    }
  }, {
    key: '_start',
    value: function _start() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(TranslateAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TranslateAnimation.prototype), '_start', this).call(this);
      var timeOut = durations.appHeightTransitionDuration;
      this.afterStartWindowTimeout = durations.appHeightTransitionTimeOut;
      if (this.minHeight >= 480) {
        var diff = this.minHeight - parseInt(this.app.$prevHeight, 10);
        diff = diff > 0 ? diff : -diff;
        if (diff > 0) {
          timeOut = timeOut + diff; //transition duration changes in accordance with the height difference between the consecutive screens
          this.afterStartWindowTimeout = timeOut;
        }
      }
      this.app.style.transitionDuration = timeOut + "ms";
    }
  }, {
    key: 'afterStart',
    value: function afterStart() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_get___default()(TranslateAnimation.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TranslateAnimation.prototype), 'afterStart', this).call(this);
      document.body.$scrollTop = 0;
    }
  }]);

  return TranslateAnimation;
}(WebAnimation);

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      internalMessage: ""
    };
  },

  computed: {
    message: function message() {
      if (this.internalMessage) {
        return this.internalMessage;
      } else {
        return "Invalid Url";
      }
    }
  },
  methods: {
    close: function close() {
      window.cbPostMessage("cb.close");
    },
    closeKey: function closeKey(event) {
      if (event.keyCode == 9) {
        document.getElementById("app").focus();
      }
    }
  },
  mounted: function mounted() {
    var messageElement = document.getElementById("message");
    if (messageElement) {
      this.internalMessage = messageElement.textContent;
    }
    window.cbPostMessage("cb.loaded");
    document.body.addEventListener("keydown", function (event) {
      if (event.keyCode == 27) {
        window.cbPostMessage("cb.close");
      }
    });
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);



window.hasClass = function (ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
};

window.addClass = function (ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
};

window.removeClass = function (ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
};

window.isDescendant = function (parent, child) {
  var node = child.parentNode;
  while (node != null) {
    if (node == parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

window.ifNativeDateSupported = function () {
  var input = document.createElement('input');
  input.setAttribute('type', 'date');
  var notADateValue = 'not-a-date';
  input.setAttribute('value', notADateValue);
  return input.value !== notADateValue;
}();

window.ifNativeTimeSupported = function () {
  var input = document.createElement('input');
  input.setAttribute('type', 'time');
  var notATimeValue = 'not-a-time';
  input.setAttribute('value', notATimeValue);
  return input.value !== notATimeValue;
}();

if (typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a != 'function') {
  Object.assign = function (target, varArgs) {
    // .length of function is 2
    'use strict';

    if (target == null) {
      // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) {
        // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

Array.prototype.findIndex = function (predicate) {
  var position = -1;
  this.some(function (value, index) {
    if (predicate(value)) {
      position = index;
      return true;
    }
  });
  return position;
};

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.lastIndexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}

(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

window.range10 = function (min, max) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  min = parseInt(min);
  max = parseInt(max);
  step = parseInt(step);
  var noOfElements = parseInt((max - min) / step) + 1;
  var moreThan10 = false;
  if (noOfElements > 10) {
    noOfElements = 10;
    moreThan10 = true;
  }
  return { array: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Array(noOfElements))).map(function (el, index) {
      return min + index * step;
    }), moreThan10: moreThan10 };
};

window.assert = function (value, message) {
  if (!value) {
    throw new Error(message || "should not happen");
  }
};

window.asyncLoad = function (url, successCall, failureCall) {
  var d = document,
      t = 'script',
      o = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
  o.src = url;
  if (successCall) {
    // reject after 30s
    var timeout = window.cbTimeout(function () {
      return failureCall;
    }, 30000);
    o.addEventListener('load', function (event) {
      clearTimeout(timeout);
      successCall.call(null, event);
    });
  }
  s.parentNode.insertBefore(o, s);
};

// Polyfill for isNaN (Source: MDN)
Number.isNaN = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default.a || function (value) {
  return value !== value;
};

// Polyfill for Array.prototype.find (Source: MDN)
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);
      var len = o.length >>> 0;
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var thisArg = arguments[1];
      var k = 0;
      while (k < len) {
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        k++;
      }
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_hosted_pages_ErrorStandalone__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_hosted_pages_ErrorStandalone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modules_hosted_pages_ErrorStandalone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_cb_link__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transitions_cb_animate__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom_polyfills_js__ = __webpack_require__(49);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('cb-animate', __WEBPACK_IMPORTED_MODULE_3__transitions_cb_animate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('cb-link', __WEBPACK_IMPORTED_MODULE_2__directives_cb_link__["a" /* default */]);

var isMobileOrTablet = function isMobileOrTablet() {
  var check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

window.isMobile = isMobileOrTablet();

window.cbTimeout = function (func, timer) {
  window.setTimeout(function () {
    try {
      func();
    } catch (error) {
      window.logger.e(error);
    }
  }, timer);
};

window.cbPostMessage = function (event) {
  if (window.parent != window) {
    window.parent.postMessage(event, "*");
  } else {
    if (window.opener) {
      window.opener.postMessage(event, "*");
    }
  }
};

if (window.self == window.top) {
  window.addClass(window.document.body, "cb-fullpage");
} else {
  window.document.body.style.background = "none";
}

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__components_modules_hosted_pages_ErrorStandalone___default.a);
  }
}).$mount("#app");

/***/ }),

/***/ 582:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-hp cb-hp--hidden",
    attrs: {
      "id": "app",
      "tabindex": "0",
      "lang": "en"
    }
  }, [_c('div', {
    staticClass: "cb-hp__wrapper"
  }, [_c('div', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (true),
      expression: "true"
    }],
    staticClass: "cb-body",
    attrs: {
      "id": "cb-body"
    }
  }, [_c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-error"
  }, [_c('div', {
    staticClass: "cb-error__content"
  }, [_vm._m(0), _vm._v("\n            " + _vm._s(_vm.message) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-hp__close",
    attrs: {
      "role": "button",
      "aria-label": "close checkout",
      "data-cb-id": "cb_close"
    },
    on: {
      "click": _vm.close,
      "keydown": _vm.closeKey
    }
  }, [_c('i', {
    staticClass: "icon-remove cb-hp__close-icon"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-error_icon"
  }, [_c('i', {
    staticClass: "icon-exclamation-circle"
  })])
}]}

/***/ })

},[504]);


// WEBPACK FOOTER //
// javascripts/hp_error.js